export const alphaNumericWithSpaceRegex = /^([A-Za-z0-9\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/i;
export const alphaNumericWithSpaceHyphenUnderscoreRegex = /^([-_A-Za-z0-9\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/i;
export const alphaNumericWithOutSpaceRegex = /^([A-Za-z0-9\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff]*)$/i;
export const alphaNumericWithAllowedSpecialCharsRegex =
    /^([A-Za-z0-9\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff-\u0026-\u002F-\u0028-\u0029-\u005B-\u005D-\u002C-\u002D\s]*)$/i;
export const numericWithOutSpaceRegex = /^([0-9]*)$/i;
